import { create } from "zustand";
import { devtools } from "zustand/middleware";
import {
  deleteCityById,
  deleteCityMappingById,
  deleteCountryById,
  deleteCountryMappingById,
  deleteCurrencyById,
  deleteCurrencyConversionById,
  deleteDistrictById,
  deleteDistrictMappingById,
  deleteOdTier,
  deleteRegionById,
  deleteRegionMappingById,
  deleteTiers,
  deleteZoneById,
  deleteZonegroupById,
  editDistrictGeometry,
  exportCities,
  exportCityMap,
  exportCountries,
  exportCountryMap,
  exportCurrency,
  exportCurrencyConversion,
  exportDistrict,
  exportDistrictMap,
  exportRegion,
  exportRegionMap,
  exportTier,
  exportZonegroup,
  exportZones,
  filterCities,
  filterCitybyCode,
  filterCountries,
  filterCountryByCity,
  filterCurrency,
  filterDistrictbyCode,
  filterDistricts,
  filterRegionbyCode,
  filterRegions,
  filterZone,
  getAllZonegroupbyHub,
  getCities,
  getCitiesTemplate,
  getCityById,
  getCityMapTemplate,
  getCityMapping,
  getCityMappingById,
  getCitybyCode,
  getCitybyCodeDes,
  getCountries,
  getCountryByCity,
  getCountryById,
  getCountryData,
  getCountryMapTemplate,
  getCountryMapping,
  getCountryMappingById,
  getCountryTemplate,
  getCurrency,
  getCurrencyConversion,
  getCurrencyConversionTemplate,
  getCurrencyTemplate,
  getDesCountryByCity,
  getDistrictById,
  getDistrictDesbyCode,
  getDistrictGeometry,
  getDistrictMapTemplate,
  getDistrictMapping,
  getDistrictMappingById,
  getDistrictTemplate,
  getDistrictbyCode,
  getDistricts,
  getOdTier,
  getRegion,
  getRegionById,
  getRegionMapTemplate,
  getRegionMapping,
  getRegionMappingById,
  getRegionTemplate,
  getRegionbyCode,
  getRegionbyCodeDes,
  getRegions,
  getTiers,
  getTiersbyId,
  getZone,
  getZoneById,
  getZoneGroupById,
  getZoneGroups,
  getZoneTemplate,
  getZonegroupTemplate,
  importCity,
  importCityMap,
  importCityShortAddress,
  importCountry,
  importCountryMap,
  importCurrency,
  importCurrencyConversion,
  importDistrict,
  importDistrictMap,
  importDistrictShortAddress,
  importRegion,
  importRegionMap,
  importZonegroup,
  importZones,
  postCities,
  postCityMapping,
  postCountries,
  postCountryMapping,
  postCurrency,
  postCurrencyConversion,
  postDistrict,
  postDistrictMapping,
  postOdTier,
  postRegionMapping,
  postRegions,
  postTiers,
  postZonegroup,
  postZones,
  updateCityById,
  updateCityMappingById,
  updateCountryById,
  updateCountryMappingById,
  updateCurrencyById,
  updateCurrencyConversionById,
  updateDistrictById,
  updateDistrictMappingById,
  updateOdTierById,
  updateRegionById,
  updateRegionMappingById,
  updateTiersById,
  updateZoneById,
  updateZonegroupById,
  validateOdpair,
} from "../../services/Configs/Config_services";

const initialValues = {
  countriesData: [],
  countriesConfigsData: [],
  countryArrayData: [],
  zoneGroupbyHubData:[],
  regionsData: [],
  districtData: [],
  citiesData: [],
  cityArray: [],
  countryData: [],
  currencyData: [],
  cityData: [],
  districtDatas: [],
  geometryData: [],
  regionData: [],
  tiersData:[],
  zoneData: [],
  regionbyCode: [],
  citybyCode: [],
  regionbyCodeDes: [],
  citybyCodeDes: [],
  districtbyCode: [],
  districtbyDescode: [],
  zoneGroupData: [],
  citybyCountyData: [],
  citybyDesCountyData:[],
  currencyFilterData: [],
};

let configStore = (set) => ({
  ...initialValues,
  exportCountries: async (params) => {
    const response = await exportCountries(params);
    return response;
  },
  getCountries: async (params) => {
    const response = await getCountries(params);
    set({ countriesData: response });
    return response;
  },
    getCountryOrders: async (params) => {
    const response = await getCountries(params);
    set({ ctyData: response });
    return response;
  },
  getCountryData: async (params) => {
    const response = await getCountryData(params);
    return response;
  },
    filterCountries: async (params) => {
    const response = await filterCountries(params);
    set({ countriesData: response });
    return response;
  },
      filterCountryConfigs: async (params) => {
    const response = await filterCountries(params);
    set({ countriesConfigsData: response });
    return response;
  },
  getCountryArray: async (params) => {
    const response = await getCountries(params);
    set({ countryArrayData: response });
    return response;
  },
  exportRegion: async (params) => {
    const response = await exportRegion(params);
    return response;
  },
  exportCities: async (params) => {
    const response = await exportCities(params);
    return response;
  },
  exportDistrict: async (params) => {
    const response = await exportDistrict(params);
    return response;
  },
  exportDistrictMap: async (params) => {
    const response = await exportDistrictMap(params);
    return response;
  },
  exportCountryMap: async (params) => {
    const response = await exportCountryMap(params);
    return response;
  },
  exportRegionMap: async (params) => {
    const response = await exportRegionMap(params);
    return response;
  },
  exportCityMap: async (params) => {
    const response = await exportCityMap(params);
    return response;
  },
  getTiers: async (params) => {
    const response = await getTiers(params);
    set({ tiersData: response });
    return response;
  },
  postTiers: async (params) => {
    const response = await postTiers(params);
    return response;
  },
  exportTier: async (params) => {
    const response = await exportTier(params);
    return response;
  },
  getTiersbyId: async (params) => {
    const response = await getTiersbyId(params);
    return response;
  },
  updateTiersById: async (params, data) => {
    const response = await updateTiersById(params, data);
    return response;
  },
  deleteTiers: async (params) => {
    const response = await deleteTiers(params);
    return response;
  },
  getOdTier: async (params) => {
    const response = await getOdTier(params);
    return response;
  },
  postOdTier: async (params) => {
    const response = await postOdTier(params);
    return response;
  },
  validateOdpair: async (params) => {
    const response = await validateOdpair(params);
    return response;
  },
  updateOdTierById: async (params, data) => {
    const response = await updateOdTierById(params, data);
    return response;
  },
  deleteOdTier: async (params) => {
    const response = await deleteOdTier(params);
    return response;
  },
  importCountry: async (data) => {
    const response = await importCountry(data);
    return response;
  },
  importRegion: async (data) => {
    const response = await importRegion(data);
    return response;
  },
  importCity: async (data) => {
    const response = await importCity(data);
    return response;
  },
  importDistrict: async (data) => {
    const response = await importDistrict(data);
    return response;
  },
      importCityShortAddress: async (data) => {
    const response = await importCityShortAddress(data);
    return response;
  },
    importDistrictShortAddress: async (data) => {
    const response = await importDistrictShortAddress(data);
    return response;
  },
  importCountryMap: async (data) => {
    const response = await importCountryMap(data);
    return response;
  },
  importRegionMap: async (data) => {
    const response = await importRegionMap(data);
    return response;
  },
  importCityMap: async (data) => {
    const response = await importCityMap(data);
    return response;
  },
  importDistrictMap: async (data) => {
    const response = await importDistrictMap(data);
    return response;
  },
  postCountries: async (data) => {
    const response = await postCountries(data);
    return response;
  },
  postCities: async (data) => {
    const response = await postCities(data);
    return response;
  },
  postDistrict: async (data) => {
    const response = await postDistrict(data);
    return response;
  },
  getCountryById: async (params) => {
    const response = await getCountryById(params);
    set({ countryData: response });
    return response;
  },
  getCountryByCity: async (params) => {
    const response = await getCountryByCity(params);
    set({ citybyCountyData: response });
    return response;
  },
  getCountryByCityOrders: async (params) => {
    const response = await filterCountryByCity(params);
    set({ citybyCode: response?.data?.data });
    return response;
  },
  getCountryByCityOrdersDes: async (params) => {
    const response = await filterCountryByCity(params);
    set({ citybyCodeDes: response?.data?.data });
    return response;
  },
  getDesCountryByCity: async (params) => {
    const response = await getDesCountryByCity(params);
    set({ citybyDesCountyData: response });
    return response;
  },
  getCityById: async (params) => {
    const response = await getCityById(params);
    set({ cityData: response });
    return response;
  },
  getRegionbyCode: async (params) => {
    const response = await getRegionbyCode(params);
    set({ regionbyCode: response?.data?.data });
    return response;
  },
  filterRegionbyCode: async (params) => {
    const response = await filterRegionbyCode(params);
    set({ regionbyCode: response?.data?.data });
    return response;
  },
  getRegionbyCodeDes: async (params) => {
    const response = await getRegionbyCodeDes(params);
    set({ regionbyCodeDes: response?.data?.data });
    return response;
  },
  getCitybyCode: async (params, params2) => {
    const response = await getCitybyCode(params, params2);
    set({ citybyCode: response?.data?.data });
    return response;
  },
  filterCitybyCode: async (params, params2) => {
    const response = await filterCitybyCode(params, params2);
    set({ citybyCode: response?.data?.data });
    return response;
  },
  getCitybyCodeDes: async (params, params2) => {
    const response = await getCitybyCodeDes(params, params2);
    set({ citybyCodeDes: response?.data?.data });
    return response;
  },
  getDistrictbyCode: async (params, params2, params3) => {
    const response = await getDistrictbyCode(params, params2, params3);
    set({ districtbyCode: response?.data?.data });
    return response;
  },
  filterDistrictbyCode: async (params, params2, params3) => {
    const response = await filterDistrictbyCode(params, params2, params3);
    set({ districtbyCode: response?.data?.data });
    return response;
  },
  getDistrictDesbyCode: async (params, params2, params3) => {
    const response = await getDistrictDesbyCode(params, params2, params3);
    set({ districtbyDescode: response.data.data });
    return response;
  },
  getDistrictById: async (params) => {
    const response = await getDistrictById(params);
    set({ districtData: response });
    return response;
  },
  getDistrictGeometry: async (params) => {
    const response = await getDistrictGeometry(params);
    set({ geometryData: response });
    return response;
  },
  editDistrictGeometry: async (params,data) => {
    const response = await editDistrictGeometry(params,data);
    return response;
  },
  getCountryTemplate: async () => {
    const response = await getCountryTemplate();
    return response;
  },
  getRegionTemplate: async () => {
    const response = await getRegionTemplate();
    return response;
  },
  getDistrictTemplate: async () => {
    const response = await getDistrictTemplate();
    return response;
  },
  getCitiesTemplate: async () => {
    const response = await getCitiesTemplate();
    return response;
  },
  getCountryMapTemplate: async () => {
    const response = await getCountryMapTemplate();
    return response;
  },
  getRegionMapTemplate: async () => {
    const response = await getRegionMapTemplate();
    return response;
  },
  getCityMapTemplate: async () => {
    const response = await getCityMapTemplate();
    return response;
  },
  getDistrictMapTemplate: async () => {
    const response = await getDistrictMapTemplate();
    return response;
  },
  updateCountryById: async (params, data) => {
    const response = await updateCountryById(params, data);
    return response;
  },
  updateCityById: async (params, data) => {
    const response = await updateCityById(params, data);
    return response;
  },
  updateDistrictById: async (params, data) => {
    const response = await updateDistrictById(params, data);
    return response;
  },
  deleteCountryById: async (params) => {
    const response = await deleteCountryById(params);
    return response;
  },
  deleteCityById: async (params) => {
    const response = await deleteCityById(params);
    return response;
  },
  deleteDistrictById: async (params) => {
    const response = await deleteDistrictById(params);
    return response;
  },
  getRegions: async (params) => {
    const response = await getRegions(params);
    set({ regionsData: response });
    return response;
  },
  getRegion: async (params) => {
    const response = await getRegion(params);
    return response;
  },
  filterRegions: async (params) => {
    const response = await filterRegions(params);
    set({ regionsData: response });
    return response;
  },
  postRegions: async (data) => {
    const response = await postRegions(data);
    return response;
  },
  getRegionById: async (params) => {
    const response = await getRegionById(params);
    set({ regionData: response });
    return response;
  },
  updateRegionById: async (params, data) => {
    const response = await updateRegionById(params, data);
    return response;
  },
  deleteRegionById: async (params) => {
    const response = await deleteRegionById(params);
    return response;
  },
  getDistricts: async (params) => {
    const response = await getDistricts(params);
    set({ districtDatas: response });
    return response;
  },
  filterDistricts: async (params) => {
    const response = await filterDistricts(params);
    set({ districtDatas: response });
    return response;
  },
  getCities: async (params) => {
    const response = await getCities(params);
    set({ citiesData: response });
    set({ cityArray: response });
    return response;
  },
  filterCities: async (params) => {
    const response = await filterCities(params);
    set({ citiesData: response });
    set({ cityArray: response });
    return response;
  },
  //Country mapping
  getCountryMapping: async (params) => {
    const response = await getCountryMapping(params);
    return response;
  },
  postCountryMapping: async (data) => {
    const response = await postCountryMapping(data);
    return response;
  },
  getCountryMappingById: async (params) => {
    const response = await getCountryMappingById(params);
    return response;
  },
  updateCountryMappingById: async (params, data) => {
    const response = await updateCountryMappingById(params, data);
    return response;
  },
  deleteCountryMappingById: async (params) => {
    const response = await deleteCountryMappingById(params);
    return response;
  },
  //Region mapping
  getRegionMapping: async (params) => {
    const response = await getRegionMapping(params);
    return response;
  },
  postRegionMapping: async (data) => {
    const response = await postRegionMapping(data);
    return response;
  },
  getRegionMappingById: async (params) => {
    const response = await getRegionMappingById(params);
    return response;
  },
  updateRegionMappingById: async (params, data) => {
    const response = await updateRegionMappingById(params, data);
    return response;
  },
  deleteRegionMappingById: async (params) => {
    const response = await deleteRegionMappingById(params);
    return response;
  },
  //City mapping
  getCityMapping: async (params) => {
    const response = await getCityMapping(params);
    return response;
  },
  postCityMapping: async (data) => {
    const response = await postCityMapping(data);
    return response;
  },
  getCityMappingById: async (params) => {
    const response = await getCityMappingById(params);
    return response;
  },
  updateCityMappingById: async (params, data) => {
    const response = await updateCityMappingById(params, data);
    return response;
  },
  deleteCityMappingById: async (params) => {
    const response = await deleteCityMappingById(params);
    return response;
  },
  //District mapping
  getDistrictMapping: async (params) => {
    const response = await getDistrictMapping(params);
    return response;
  },
  postDistrictMapping: async (data) => {
    const response = await postDistrictMapping(data);
    return response;
  },
  getDistrictMappingById: async (params) => {
    const response = await getDistrictMappingById(params);
    return response;
  },
  updateDistrictMappingById: async (params, data) => {
    const response = await updateDistrictMappingById(params, data);
    return response;
  },
  deleteDistrictMappingById: async (params) => {
    const response = await deleteDistrictMappingById(params);
    return response;
  },
  //get zones
  getZone: async (params) => {
    const response = await getZone(params);
    set({ zoneData: response });
    return response;
  },
  //filter zones
  filterZone: async (params) => {
    const response = await filterZone(params);
    set({ zoneData: response });
    return response;
  },
  //getbyId-zone
  getZoneById: async (params) => {
    const response = await getZoneById(params);
    return response;
  },
  //post zones
  postZones: async (data) => {
    const response = await postZones(data);
    return response;
  },
  //update zones
  updateZoneById: async (params, data) => {
    const response = await updateZoneById(params, data);
    return response;
  },
  //delete zones
  deleteZoneById: async (params) => {
    const response = await deleteZoneById(params);
    return response;
  },
  //zone template
  getZoneTemplate: async () => {
    const response = await getZoneTemplate();
    return response;
  },
  //zone export
  exportZones: async (params) => {
    const response = await exportZones(params);
    return response;
  },
  //zone import
  importZones: async (data) => {
    const response = await importZones(data);
    return response;
  },
  //zone groups
  getZoneGroups: async (params) => {
    const response = await getZoneGroups(params);
    set({ zoneGroupData: response });
    return response;
  },
  //getbyId-zone group
  getZoneGroupById: async (params) => {
    const response = await getZoneGroupById(params);
    return response;
  },
  //post zonegroup
  postZonegroup: async (data) => {
    const response = await postZonegroup(data);
    return response;
  },
  //update zonegroup
  updateZonegroupById: async (params, data) => {
    const response = await updateZonegroupById(params, data);
    return response;
  },
  //delete zonegroup
  deleteZonegroupById: async (params) => {
    const response = await deleteZonegroupById(params);
    return response;
  },
  //zone group template
  getZonegroupTemplate: async () => {
    const response = await getZonegroupTemplate();
    return response;
  },
  //zone group export
  exportZonegroup: async (params) => {
    const response = await exportZonegroup(params);
    return response;
  },
  //zone group import
  importZonegroup: async (params) => {
    const response = await importZonegroup(params);
    return response;
  },
  getAllZonegroupbyHub: async (params) => {
    const response = await getAllZonegroupbyHub(params);
    set({ zoneGroupbyHubData: response });
    return response;
  },
  getCurrency: async (params) => {
    const response = await getCurrency(params);
    set({ currencyData: response });
    return response;
  },
  filterCurrency: async (params) => {
    const response = await filterCurrency(params);
    set({ currencyData: response });
    set({ currencyFilterData: response });
    return response;
  },
  postCurrency: async (params) => {
    const response = await postCurrency(params);
    return response;
  },
  deleteCurrencyById: async (params) => {
    const response = await deleteCurrencyById(params);
    return response;
  },
  updateCurrencyById: async (params, data) => {
    const response = await updateCurrencyById(params, data);
    return response;
  },
  getCurrencyTemplate: async () => {
    const response = await getCurrencyTemplate();
    return response;
  },
  exportCurrency: async (params) => {
    const response = await exportCurrency(params);
    return response;
  },
  importCurrency: async (params) => {
    const response = await importCurrency(params);
    return response;
  },
  getCurrencyConversion: async (params) => {
    const response = await getCurrencyConversion(params);
    return response;
  },
  postCurrencyConversion: async (params) => {
    const response = await postCurrencyConversion(params);
    return response;
  },
  deleteCurrencyConversionById: async (params) => {
    const response = await deleteCurrencyConversionById(params);
    return response;
  },
  updateCurrencyConversionById: async (params, data) => {
    const response = await updateCurrencyConversionById(params, data);
    return response;
  },
  getCurrencyConversionTemplate: async () => {
    const response = await getCurrencyConversionTemplate();
    return response;
  },
  exportCurrencyConversion: async (params) => {
    const response = await exportCurrencyConversion(params);
    return response;
  },
  importCurrencyConversion: async (params) => {
    const response = await importCurrencyConversion(params);
    return response;
  },
  setReactGeometry: (data) => set({ geometryData: data }),
});

configStore = devtools(configStore);

export const useConfigStore = create(configStore);
